import * as components from './components'
import {Components as CoreComponents, registerComponents as registerCoreComponents} from "@bvm/core";

const prefix = "BvmRmt";

// Auto register all components when library is included
const registerComponents = (Vue, options = {}) => {
    registerCoreComponents(Vue, "Bvm", CoreComponents);

    for (let key in components) {
        let _key = options.prefix ? options.prefix + key : key;
        Vue.component(prefix + _key, components[key]);
    }
};

// Register Vue
if (typeof window !== 'undefined' && window.Vue) {
    registerComponents(window.Vue);
}

export { registerComponents }

export default { registerComponents }
